import { StudentSectionSettingTypeCodes } from 'const';
import { professionWidgetVisibilityHooks } from 'hooks';
import { IRootState } from 'reducers';
import {
  professionAdditionalEducationSelector,
  professionEventsSelector,
  professionGiaWorldSkillsSelector,
  professionJobsSelector,
  professionRewardsSelector,
  userFunctionalitySelector,
} from 'selectors';
import store from 'store';
import { getDataLoadRequests, isDefined } from 'utils';

import { SectionLoaderConfig } from './types';

export const getProfessionLoaderConfig = (): SectionLoaderConfig => {
  const state: IRootState = store.getState();
  const user = userFunctionalitySelector(state);
  const requests = getDataLoadRequests();

  const recommendationsRequests = [
    ...requests.professionProforientation,
    ...requests.professionProforientationRecommendationEvents,
  ];

  return [
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.professionProforientation,
      requests: requests.professionProforientation,
      loadingSelector: (state) => state.proforientation,
      dataSelector: () => true,
      useWidgetVisibility: professionWidgetVisibilityHooks.useProforientation,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.professionApplications,
      requests: requests.professionProforientationRecommendationApplications,
      loadingSelector: (state) => state.proforientationRecommendationApplications,
      dataSelector: (state) => {
        const data = state.proforientationRecommendationApplications.content;
        return (
          isDefined(data) &&
          (data.applicationsProfTests.length > 0 ||
            data.applicationsExcursions.length > 0 ||
            data.applicationsDod.length > 0)
        );
      },
      useWidgetVisibility: professionWidgetVisibilityHooks.useProforientationApplications,
      isDisabled: user.isAdmin,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.professionProforientationRecommendations,
      requests: recommendationsRequests,
      loadingSelector: (state) => state.proforientation,
      dataSelector: () => true,
      useWidgetVisibility: professionWidgetVisibilityHooks.useProforientationRecommendations,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.professionProforientationEvents,
      requests: requests.professionProforientation,
      loadingSelector: (state) => state.proforientation,
      dataSelector: () => true,
      useWidgetVisibility: professionWidgetVisibilityHooks.useProforientationEvents,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.professionReward,
      requests: requests.professionRewards,
      loadingSelector: professionRewardsSelector,
      dataSelector: (state) => professionRewardsSelector(state).content.length > 0,
      useWidgetVisibility: professionWidgetVisibilityHooks.useReward,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.professionJob,
      requests: requests.professionJobs,
      loadingSelector: professionJobsSelector,
      dataSelector: (state) => professionJobsSelector(state).content.length > 0,
      useWidgetVisibility: professionWidgetVisibilityHooks.useJobs,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.professionMetaskills,
      requests: requests.professionMetaSkills,
      loadingSelector: (state) => state.studentMetaSkills,
      dataSelector: (state) => state.studentMetaSkills.content.length > 0,
      useWidgetVisibility: professionWidgetVisibilityHooks.useMetaSkills,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.professionEducation,
      requests: requests.professionEducation,
      loadingSelector: professionAdditionalEducationSelector,
      dataSelector: (state) => professionAdditionalEducationSelector(state).content.length > 0,
      useWidgetVisibility: professionWidgetVisibilityHooks.useAdditionalEducation,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.professionEvent,
      requests: requests.professionEvents,
      loadingSelector: professionEventsSelector,
      dataSelector: (state) => professionEventsSelector(state).content.length > 0,
      useWidgetVisibility: professionWidgetVisibilityHooks.useEvents,
    },
    {
      subsectionTypeCode: StudentSectionSettingTypeCodes.professionGiaWorldskills,
      requests: requests.professionGiaWorldSkills,
      loadingSelector: professionGiaWorldSkillsSelector,
      dataSelector: (state) => professionGiaWorldSkillsSelector(state).content.length > 0,
      useWidgetVisibility: professionWidgetVisibilityHooks.useGiaWorldSkills,
    },
  ] as const;
};
